import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useMySchoolProfile } from '../hooks/useMySchoolProfile';
import { shouldUseSchoolDashboard } from '../lib/school/resolveSchoolDashboardTarget';

/**
 * Sends school admins and linked teachers to /school when they have a resolved school profile.
 * Preserves schedule-related paths by mapping them to their /school equivalents.
 */
export default function AppSchoolRedirect({ children }) {
  const { user } = useAuth();
  const { hasProfile, loading } = useMySchoolProfile();
  const location = useLocation();
  const role = user?.role?.toLowerCase();

  if (!shouldUseSchoolDashboard(role) || loading || !hasProfile) {
    return children;
  }

  // Allow direct access to books, lessons, macroconcepts, and profile
  const currentPath = location.pathname;
  if (
    currentPath.includes('/lessons/') ||
    currentPath.includes('/lesson/') ||
    currentPath.includes('/books/') ||
    currentPath.includes('/macroconcepts/') ||
    currentPath.includes('/profile') ||
    currentPath.includes('/viedma') ||
    currentPath.includes('/quran')
  ) {
    return children;
  }

  // If the teacher was trying to reach a schedule page, send them to /school/schedule
  if (currentPath.includes('class-schedule') || currentPath.includes('/schedule')) {
    return <Navigate to={`/school/schedule${location.search}`} replace />;
  }

  return <Navigate to="/school" replace />;
}
